import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// This is a utility function for deep merging objects, useful for combining translation files.
const deepMerge = (target, source) => {
    const output = { ...target };
    if (target && typeof target === 'object' && source && typeof source === 'object') {
        Object.keys(source).forEach(key => {
            if (source[key] && typeof source[key] === 'object' && !Array.isArray(source[key])) {
                if (!(key in target)) {
                    Object.assign(output, { [key]: source[key] });
                } else {
                    output[key] = deepMerge(target[key], source[key]);
                }
            } else {
                Object.assign(output, { [key]: source[key] });
            }
        });
    }
    return output;
};

// Dynamically import all translation files
const req = require.context('./locales', true, /\.json$/);
const resources = {};
const supportedLngs = [];

req.keys().forEach(file => {
    const [lng, ns] = file.replace('./', '').replace('.json', '').split('/');
    
    if (!supportedLngs.includes(lng)) {
        supportedLngs.push(lng);
    }

    resources[lng] = resources[lng] || {};
    resources[lng][ns] = req(file);
});

// Manually merge 'translation' and 'translation_additions'
supportedLngs.forEach(lng => {
    if (resources[lng] && resources[lng].translation && resources[lng].translation_additions) {
        resources[lng].translation = deepMerge(resources[lng].translation, resources[lng].translation_additions);
    }
});


i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    supportedLngs,
    fallbackLng: 'en',
    
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },

    // Define all possible namespaces
    ns: ['translation', 'badgeconfig', 'languageselector', 'trendingtgasidebar'],
    defaultNS: 'translation',
    
    // Use default separators
    nsSeparator: ':',
    keySeparator: '.',

    react: {
      useSuspense: true,
    },
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
